import { $ } from './el.JsModules.js';

(function () {
  'use strict';

  Array.prototype.rotate = function (n) {
    n = n % this.length;
    while (this.length && n < 0) {
      n += this.length;
    }
    this.push.apply(this, this.splice(0, n));
    return this;
  };

  // Call this like numberVariable.mod(5)
  Number.prototype.mod = function (n) {
    return ((this % n) + n) % n;
  };
  /**
   * Email validation
   */
  elabs.Utils.validateEmail = function (email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email.toLowerCase());
  };

  /**
   * recursively get all text nodes as an array for a given element
   */
  elabs.Utils.getTextNodes = function (node) {
    const childTextNodes = [];

    if (typeof node.hasChildNodes !== 'function') {
      node = node[0];
    }

    if (!node.hasChildNodes()) {
      return;
    }

    const childNodes = node.childNodes;
    for (let i = 0; i < childNodes.length; i++) {
      if (childNodes[i].nodeType === Node.TEXT_NODE) {
        childTextNodes.push(childNodes[i]);
      } else if (childNodes[i].nodeType === Node.ELEMENT_NODE) {
        Array.prototype.push.apply(childTextNodes, elabs.Utils.getTextNodes(childNodes[i]));
      }
    }

    return childTextNodes;
  };

  /**
   * Wrap each character in a span element
   */
  elabs.Utils.wrapEachCharacter = function (textNode) {
    const text = textNode.nodeValue;
    const parent = textNode.parentNode;

    const characters = text.split('');
    let i = 0;
    characters.forEach((character) => {
      // Space characters do not need to be animated
      if ($.trim(character).length === 0) {
        const whitespaceElement = document.createElement('span');
        const whitespaceElementClassAttr = document.createAttribute('class');
        whitespaceElementClassAttr.value = 'letter-anim-white-space';
        whitespaceElement.setAttributeNode(whitespaceElementClassAttr);
        const whitespaceCharacterNode = document.createTextNode(' ');
        whitespaceElement.appendChild(whitespaceCharacterNode);
        parent.insertBefore(whitespaceElement, textNode);
        return true; // continue
      }

      const element = document.createElement('span');
      const classAttr = document.createAttribute('class');
      classAttr.value = `letter-anim letter-anim-${i++}`;

      const dataCharAttr = document.createAttribute('data-char');
      dataCharAttr.value = character;

      element.setAttributeNode(classAttr);
      element.setAttributeNode(dataCharAttr);

      const characterNode = document.createTextNode(character);
      element.appendChild(characterNode);

      parent.insertBefore(element, textNode);
    });

    parent.removeChild(textNode);
  };

  elabs.Utils.hashCode = function (string) {
    let hash = 0,
      i,
      chr;
    if (string.length === 0) {
      return hash;
    }
    for (i = 0; i < string.length; i++) {
      chr = string.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  };

  // Toast queue for handling multiple toasts in succession
  const toastQueue = [];
  let isShowingToast = false;

  const _showNextToast = function () {
    if (toastQueue.length === 0) {
      isShowingToast = false;
      return;
    }

    isShowingToast = true;
    const { message, iconUrl, appearanceTimeArg } = toastQueue.shift();

    let appearanceTime = Math.max(5000, message.length * 70);
    if (appearanceTimeArg) {
      appearanceTime = appearanceTimeArg;
    }

    let iconHtml = '';
    if (iconUrl) {
      iconHtml = `<img class='toast-icon' src='${iconUrl}' alt='' height="17" />`;
    }

    const notificationOverlayElement = $(
      `<div class='toast-container'><div class='toast-content'>${iconHtml} ${message}</div></div>`,
    );
    elabs.bodyElement.append(notificationOverlayElement);

    requestTimeout(() => {
      notificationOverlayElement.addClass('toast-container--visible');
      requestTimeout(() => {
        notificationOverlayElement.addClass('toast-container--animate-out');
        setTimeout(() => {
          notificationOverlayElement.remove();
          // Wait 0.5 seconds before showing next toast
          requestTimeout(() => {
            _showNextToast();
          }, 500);
        }, 500);
      }, appearanceTime);
    }, 1);
  };

  // icon is optional. It should be a white png or svg. appearanceTimeArg is also optional.
  elabs.Utils.showToast = function (message, iconUrl, appearanceTimeArg) {
    if (!message) {
      return;
    }

    toastQueue.push({ message, iconUrl, appearanceTimeArg });

    if (!isShowingToast) {
      _showNextToast();
    }
  };

  elabs.Utils.htmlEncode = function (value) {
    return $('<div/>').text(value).html();
  };

  elabs.Utils.htmlDecode = function (value) {
    return $('<div/>').html(value).text();
  };

  elabs.Utils.encodeHtmlForAttribute = function (html) {
    return html
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;') // escape double quotes
      .replace(/'/g, '&#39;') // optionally escape single quotes
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  };

  elabs.Utils.isNumber = function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
  };

  elabs.Utils.debounce = function (fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  /**
   * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
   * @param {function} fn The callback function
   * @param {int} delay The delay in milliseconds
   */
  window.requestInterval = function (fn, delay) {
    let start = new Date().getTime(),
      handle = {};

    function loop() {
      const current = new Date().getTime(),
        delta = current - start;

      if (delta >= delay) {
        fn.call();
        start = new Date().getTime();
      }

      handle.value = requestAnimationFrame(loop);
    }

    handle.value = requestAnimationFrame(loop);
    return handle;
  };

  /**
   * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
   * @param {int|object} handle The callback function
   */
  window.clearRequestInterval = function (handle) {
    if (typeof handle === 'number') {
      handle = { value: handle };
    }
    window.cancelAnimationFrame(handle.value);
  };

  /**
   * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
   * @param {function} fn The callback function
   * @param {int} delay The delay in milliseconds
   */

  window.requestTimeout = function (fn, delay) {
    const start = new Date().getTime(),
      handle = {};

    function loop() {
      const current = new Date().getTime(),
        delta = current - start;

      delta >= delay ? fn.call() : (handle.value = requestAnimationFrame(loop));
    }

    handle.value = requestAnimationFrame(loop);
    return handle;
  };

  /**
   * Behaves the same as clearTimeout except uses cancelRequestAnimationFrame() for better performance
   * @param {int|object} handle The callback function
   */
  window.clearRequestTimeout = function (handle) {
    if (typeof handle === 'number') {
      handle = { value: handle };
    }
    window.cancelAnimationFrame(handle.value);
  };

  const prepareImage = (imgUrl, alt) => {
    const sizes = [
      '320',
      '375',
      '400',
      '550',
      '700',
      '900',
      '1050',
      '1200',
      '1400',
      '1600',
      '1800',
      '2000',
      '2200',
      '2400',
      '2600',
    ];
    return {
      src: imgUrl,
      srcset: sizes.map((size) => `${imgUrl}&width=${size} ${size}w`).join(', '),
      sizes: '100vw',
      alt,
    };
  };

  // Cache for store locations data
  let storeLocationsCache = null;
  // Promise to prevent multiple simultaneous fetches
  let storeLocationsPromise = null;
  // Cache time-to-live (20 minutes)
  const TTL_MS = 20 * 60 * 1000;

  /**
   * Fetch and cache store locations from remote URL, using localStorage with TTL
   * @param {string} URL - The URL to fetch locations from (default provided)
   * @returns {Promise<Array>} Resolves to an array of location objects
   */
  const getStoreLocations = async (URL = 'https://services-usa.one.world/locations') => {
    const now = Date.now();
    const cached = localStorage.getItem('store_locations');
    const cachedTime = localStorage.getItem('store_locations_time');

    // Use cached locations if not expired
    if (!storeLocationsCache && cached && cachedTime && now - Number(cachedTime) < TTL_MS) {
      storeLocationsCache = JSON.parse(cached);
    }

    if (storeLocationsCache) {
      return storeLocationsCache;
    }
    if (storeLocationsPromise) {
      return storeLocationsPromise;
    }

    // Fetch fresh data and cache it
    storeLocationsPromise = (async () => {
      try {
        const res = await fetch(URL);
        let { locations } = await res.json();

        // Process each location to add image objects with prepared srcsets
        locations = locations.map((location) => ({
          ...location,
          mobile_images: location.mobile_images.map((image, index) =>
            prepareImage(image, `Location ${location.name} mobile image ${index + 1}`),
          ),
          desktop_images: location.desktop_images.map((image, index) =>
            prepareImage(image, `Location ${location.name} desktop image ${index + 1}`),
          ),
        }));

        storeLocationsCache = locations;
        localStorage.setItem('store_locations', JSON.stringify(locations));
        localStorage.setItem('store_locations_time', now.toString());

        return locations;
      } catch (e) {
        console.error('Error in el.Utils.js, function: getStoreLocations', e);
        return [];
      } finally {
        storeLocationsPromise = null;
      }
    })();

    return storeLocationsPromise;
  };

  // Cache for geo location data
  let geoLocationCache = null;
  // Promise to prevent multiple simultaneous fetches
  let geoLocationPromise = null;
  // Geo location cache time-to-live (7 days)
  const GEO_TTL_MS = 7 * 24 * 60 * 60 * 1000;

  /**
   * Fetch and cache the visitor geo location from remote URL, using localStorage with TTL
   * @param {string} URL - The URL to fetch geo location from (default provided)
   * @returns {Promise<object|null>} Resolves to an object with closestLocation and locationDistances, or null on failure
   */
  const getGeoLocation = async (URL = 'https://services-usa.one.world/geo-location') => {
    const now = Date.now();
    const cached = localStorage.getItem('geo_location');
    const cachedTime = localStorage.getItem('geo_location_time');

    // Use cached geo location if not expired
    if (!geoLocationCache && cached && cachedTime && now - Number(cachedTime) < GEO_TTL_MS) {
      geoLocationCache = JSON.parse(cached);
    }

    if (geoLocationCache) {
      return geoLocationCache;
    }
    if (geoLocationPromise) {
      return geoLocationPromise;
    }

    // Fetch fresh data and cache it
    geoLocationPromise = (async () => {
      try {
        const res = await fetch(URL);
        const data = await res.json();

        geoLocationCache = data;
        localStorage.setItem('geo_location', JSON.stringify(data));
        localStorage.setItem('geo_location_time', now.toString());

        return data;
      } catch (e) {
        console.error('Error in el.Utils.js, function: getGeoLocation', e);
        return null;
      } finally {
        geoLocationPromise = null;
      }
    })();

    return geoLocationPromise;
  };

  // ISO codes of North, Central and South America, including the Caribbean
  const AMERICAS_COUNTRY_CODES =
    'AG,AI,AR,AW,BB,BL,BM,BO,BQ,BR,BS,BZ,CA,CL,CO,CR,CU,CW,DM,DO,EC,FK,GD,GF,GL,GP,GT,GY,HN,HT,JM,KN,KY,LC,MF,MQ,MS,MX,NI,PA,PE,PM,PR,PY,SR,SV,SX,TC,TT,US,UY,VC,VE,VG,VI'.split(
      ',',
    );

  // Promise to prevent multiple simultaneous fetches
  let detectedCountryCodePromise = null;

  /**
   * Detect the visitor country code, regardless of the market the storefront falls back to
   * @returns {Promise<string|null>} Resolves to a two letter ISO country code, or null on failure
   */
  const getDetectedCountryCode = async () => {
    if (detectedCountryCodePromise) {
      return detectedCountryCodePromise;
    }

    detectedCountryCodePromise = (async () => {
      try {
        const res = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true`);
        const data = await res.json();

        return data?.detected_values?.country?.handle?.toUpperCase() || null;
      } catch (e) {
        console.error('Error in el.Utils.js, function: getDetectedCountryCode', e);
        return null;
      }
    })();

    return detectedCountryCodePromise;
  };

  /**
   * Check if the visitor is located outside of the Americas
   * @returns {Promise<boolean>} Resolves to false when the country cannot be detected
   */
  const isVisitorOutsideAmericas = async () => {
    const countryCode = await getDetectedCountryCode();

    if (!countryCode) {
      return false;
    }

    return !AMERICAS_COUNTRY_CODES.includes(countryCode);
  };

  elabs.Utils.createKlaviyoBackInStockAlert = async (email, variantId) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        variantId,
      }),
    };

    return await fetch('https://services-usa.one.world/back-in-stock/subscribe', requestOptions);
  };

  /**
   * Change the primary location in the cached store locations
   * @param {object} location - The location object to set as primary
   */
  const changePrimaryLocation = (location) => {
    let locations = JSON.parse(localStorage.getItem('store_locations'));

    if (!locations) {
      console.log('ERROR in changePrimaryLocation: NO LOCATIONS');
      return;
    }

    locations = locations.map((_loc) => ({
      ..._loc,
      primary: _loc.name === location.name,
    }));

    localStorage.setItem('store_locations', JSON.stringify(locations));
  };

  // Shared across www.one.world and usa.one.world, holds 'gb' or 'us'
  const STORE_CHOICE_COOKIE = 'Explicit-Country-Choice';
  const STORE_CHOICE_MAX_AGE = 365 * 24 * 60 * 60;
  const BOT_USER_AGENT_PATTERN = /bot|crawl|spider|slurp|facebookexternalhit|embedly|lighthouse|headlesschrome/i;

  /**
   * Read the store the visitor has explicitly chosen
   * @returns {string|null} 'gb', 'us' or null when the visitor has not chosen yet
   */
  const getExplicitStoreChoice = () => {
    const match = document.cookie.match(new RegExp(`${STORE_CHOICE_COOKIE}=([a-zA-Z]{2})`));

    return match ? match[1].toLowerCase() : null;
  };

  /**
   * Remember the store the visitor has explicitly chosen
   * @param {string} countryCode - 'gb' for the UK store, 'us' for the USA store
   */
  const setExplicitStoreChoice = (countryCode) => {
    const domain = window.location.hostname.endsWith('one.world') ? '; domain=.one.world' : '';
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie = `${STORE_CHOICE_COOKIE}=${countryCode}; path=/; max-age=${STORE_CHOICE_MAX_AGE}; SameSite=Lax${domain}${secure}`;
  };

  /**
   * Detect search engine crawlers, which must never be redirected or shown popovers
   * @returns {boolean}
   */
  const isBot = () => BOT_USER_AGENT_PATTERN.test(navigator.userAgent);

  elabs.Utils.getStoreLocations = getStoreLocations;
  elabs.Utils.getGeoLocation = getGeoLocation;
  elabs.Utils.getExplicitStoreChoice = getExplicitStoreChoice;
  elabs.Utils.setExplicitStoreChoice = setExplicitStoreChoice;
  elabs.Utils.isBot = isBot;
  elabs.Utils.getDetectedCountryCode = getDetectedCountryCode;
  elabs.Utils.isVisitorOutsideAmericas = isVisitorOutsideAmericas;
  elabs.Utils.changePrimaryLocation = changePrimaryLocation;

  // Optionally pre-fetch locations on load
  getStoreLocations();
})((elabs.Utils = elabs.Utils || {}));
